module.exports = __webpack_public_path__ + "static/media/4-4-4@2x.3402b18a.png";